import neff from 'neff/cjs'
import thunk from 'redux-thunk' // needed for async actions
import { createLogger } from 'redux-logger' // Redux middleware for console.logging actions
import reduxAnalytics from 'redux-analytics'
import { trackAction } from '../../lib/analytics/fpti'
import history from '../../transfer/stores/configureHistory'
import { routerMiddleware } from 'connected-react-router'

// ADD a simple flag to turn on / off...
const SHOW_LOGGER = neff.isEnabled('verbose-logging')
const logger = createLogger({
  level: 'info',
  collapsed: true,
  predicate: (getState, action) => SHOW_LOGGER, // hide or show logs
})

const analytics = reduxAnalytics(function onTrackableReduxAction({ type }) {
  trackAction(type)
})

const router = routerMiddleware(history)

export default [thunk, logger, router, analytics]
